import { useState } from "react";

import { cn } from "~/lib/utils";

function personInitials(name: string | null | undefined, fallback = "?"): string {
  const words = name?.trim().split(/\s+/).filter(Boolean) ?? [];
  if (words.length === 0) return fallback;
  const initials = words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
  return initials || fallback;
}

export function PersonAvatar({
  name,
  avatarUrl,
  className,
  fallback = "?",
}: {
  readonly name: string | null | undefined;
  readonly avatarUrl: string | null | undefined;
  readonly className: string;
  readonly fallback?: string;
}) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const label = name?.trim() || "Unassigned";
  const showImage = Boolean(avatarUrl) && failedUrl !== avatarUrl;

  return showImage && avatarUrl ? (
    <img
      src={avatarUrl}
      alt={label}
      title={label}
      className={cn(className, "object-cover")}
      referrerPolicy="no-referrer"
      onError={() => setFailedUrl(avatarUrl)}
    />
  ) : (
    <span title={label} className={className}>
      {personInitials(name, fallback)}
    </span>
  );
}
